import { useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RowMouseEventHandlerParams } from 'react-virtualized'
import { CloseLateralModalSimple, ModalFullCentered } from '../../../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { TableInstanceType } from '../../../../../../../../baseComponents/TwinTable/types'
import TableAllCustomers from '../../../../../../../../specificComponents/Customers/TableAllCustomers'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../../../utils/reducers/company/employees'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'

type ModalCustomerListingTPVProps = ModalEditComponentProps & ReduxModalCustomerListingTPV & {
    handleSelectCustomer: (CustomerId: number, e: RowMouseEventHandlerParams) => Promise<void>
}

const ModalCustomerListingTPV: React.FC<ModalCustomerListingTPVProps> = ({ handleSelectCustomer, ...rest }) => {
    const [tableInstance, setTableInstance] = useState<TableInstanceType>(null)
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
            <TableAllCustomers setTableInstance={setTableInstance} userPermissions={getUserPermissions('customer.profile.main') || { n: 1, permission: 'read' }} setOpened={() => rest.setOpened(null)} tableInstance={tableInstance} employees={rest.employees} onRowClick={(value, _rowData, e) => handleSelectCustomer(value, e)} />
        </ModalFullCentered>
    )
}

const modalCustomerListingTPVDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

type ReduxModalCustomerListingTPV = ConnectedProps<typeof modalCustomerListingTPVConnect>
const mapModalCustomerListingTPVConnector = (state: AllReduxPayloads) => ({ employees: state.employees })
const modalCustomerListingTPVConnect = connect(mapModalCustomerListingTPVConnector, modalCustomerListingTPVDispatch)
const modalCustomerListingTPVLoading = withLoading(ModalCustomerListingTPV, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
const ModalCustomerListingTPVConnect = modalCustomerListingTPVConnect(modalCustomerListingTPVLoading)

export default ModalCustomerListingTPVConnect